module.exports = {"445202001":"榕华街道","445202002":"新兴街道","445202003":"中山街道","445202004":"西马街道","445202005":"东兴街道","445202006":"榕东街道","445202007":"仙桥街道","445202008":"梅云街道","445202009":"东升街道","445202010":"东阳街道","445202011":"渔湖街道","445202102":"炮台镇","445202103":"地都镇","445202105":"登岗镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445202.json
// module id = 2185
// module chunks = 0